// Number/quantity/percent formatting via Intl (no dependency).
export const formatNumber = (value, options) =>
  new Intl.NumberFormat('en-US', options).format(Number(value ?? 0));

// Compliance quantities keep every decimal; Intl's default rounds to 3.
const QUANTITY_PRECISION = { maximumFractionDigits: 20 };

export const formatQuantity = (quantity, options) => {
  if (!quantity) return '';
  const amount = formatNumber(quantity.amount, { ...QUANTITY_PRECISION, ...options });
  return quantity.unit ? `${amount} ${quantity.unit}` : amount;
};

export const formatFactorOrDash = (value) =>
  value ? formatNumber(value, { useGrouping: false, ...QUANTITY_PRECISION }) : '-';

export const formatPercent = (value, digits = 1) =>
  `${formatNumber(value, { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`;

// Table-cell variants: a dash rather than an empty gap when there is no value.
export const formatQuantityOrDash = (amount, unit) =>
  amount == null ? '-' : formatQuantity({ amount, unit });

export const formatNumberOrDash = (value) =>
  value == null || value === '' ? '-' : formatNumber(value);

export const formatPercentOrDash = (value, digits) =>
  value == null ? '-' : formatPercent(value, digits);

// "{quantity} {unit}" per entry with a real quantity, comma-joined and parenthesized.
export const formatSecondaryQuantities = (entries) => {
  const parts = entries
    .filter(([quantity]) => quantity != null)
    .map(([quantity, unit]) => `${quantity} ${unit ?? ''}`.trim());
  return parts.length ? `(${parts.join(', ')})` : '';
};

export const formatMoney = (money) => {
  if (!money) return '';
  return formatNumber(money.amount, { style: 'currency', currency: money.currency ?? 'USD' });
};
